import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=21987720&scoped=true&"
import script from "./TransactionSummary.vue?vue&type=script&lang=ts&"
export * from "./TransactionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionSummary.vue?vue&type=style&index=0&id=21987720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21987720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
